<template>
  <div>
    <div>
      <v-btn
        :color="color"
        class="fb-btn text-none"
        :class="!$vuetify.breakpoint.xs ? 'px-3 py-3' : 'px-3 py-2'"
        block
        outlined
        style="height: max-content; letter-spacing: normal; display: inline-table"
        @click="startPayment()">
        <v-row align="center" no-gutters>
          <v-col>
            <v-row no-gutters>
              <v-col class="d-flex" cols="12" style="align-items: center">
                <v-img class="mr-4" style="border-radius: 5px; max-width: 30px; max-height: 30px" :src="setImage()" @error="handleImageError"></v-img>
                <div>
                  <span class="font-weight-medium d-block" style="font-size: 15px; color: #333333; white-space: normal; line-height: 18px; text-align: left">
                    {{ processorName }}
                  </span>
                  <span
                    v-if="processorLegend && processorLegend !== '' && $vuetify.breakpoint.xs"
                    class="font-weight-regular d-block pt-1"
                    style="font-size: 12px; color: #545454; white-space: normal; line-height: 14px; text-align: left">
                    {{ processorLegend }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="processorLegend && processorLegend !== '' && !$vuetify.breakpoint.xs" no-gutters>
              <v-col class="d-flex mt-1" cols="12" style="text-align: left">
                <span class="font-weight-regular" style="font-size: 11px; color: #545454; white-space: normal; line-height: 14px">
                  {{ processorLegend }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-btn>
      <div id="root"></div>
    </div>

    <v-overlay v-if="overlay" :absolute="absolute">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12"> {{ $t(`yunoComponent.overlayMessage.${overlayMessage}`) }} </v-col>
        <v-col cols="10" sm="12">
          <v-progress-linear v-if="progress" :color="color" indeterminate rounded height="10"></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>

    <v-overlay v-if="errorToShow.show" class="align-start" :opacity="1" style="z-index: 1000000" color="white">
      <v-row justify="center" no-gutters style="margin-left: 15%; margin-right: 15%; margin-top: 100px">
        <v-col cols="12" class="d-flex justify-center">
          <div class="prominent-icon-wrapper">
            <div class="prominent-icon-bg" :style="{backgroundColor: errorToShow.textColor}"></div>
            <div class="prominent-icon">
              <v-icon :color="errorToShow.textColor" size="30"> {{ errorToShow.icon }} </v-icon>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="text-center mt-3">
          <span class="font-weight-bold" style="font-size: 15px; color: #333333"> {{ $t(`yunoComponent.errorMessage.${errorToShow.code}.title`) }} </span>
        </v-col>
        <v-col cols="12" class="text-center mt-2">
          <span class="font-weight-medium" style="font-size: 15px; color: #333333"> {{ $t(`yunoComponent.errorMessage.${errorToShow.code}.message`) }} </span>
        </v-col>
        <v-col cols="12" class="text-center mt-3">
          <v-btn class="white--text" elevation="0" rounded large :color="color" style="letter-spacing: normal; font-size: 15px; font-weight: 400" @click="backButtonRedirect(errorToShow.code)">
            {{ $t('yunoComponent.errorBackButton') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import axios from 'axios'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Yuno',
  props: ['data'],
  data: () => ({
    progress: false,
    overlay: false,
    overlayMessage: 'loading',
    absolute: true,
    flag: 0,
    imageLoaded: false,
    //errors
    errorMPRedirect: false,
    errorCreatePayment: false,
    errorPromotionValidation: false,
    errorPromotionFailed: false,
    imageError: false,
    currentErrors: [],
    errorToShow: {
      message: '',
      textColor: '',
      buttonColor: '',
      type: '',
      icon: '',
      backButton: false,
      show: false,
      code: ''
    },
    errorsDict: {
      errorCreatePayment: {
        textColor: '#F57C00',
        buttonColor: '#F57C00',
        type: 'info',
        icon: 'mdi-information',
        backButton: true,
        show: true,
        code: 'ERR_YUNO_METHOD'
      },
      errorPromotionValidation: {
        textColor: '#F57C00',
        buttonColor: '#F57C00',
        type: 'info',
        icon: 'mdi-information',
        backButton: true,
        show: true,
        code: 'ERR_BINES_VALIDATION'
      },
      errorPromotionFailed: {
        textColor: '#F57C00',
        buttonColor: '#F57C00',
        type: 'info',
        icon: 'mdi-information',
        backButton: true,
        show: true,
        code: 'ERR_BINES_FAILED'
      }
    }
  }),
  computed: {
    ...mapState(['color', 'idSessionHash', 'x_country', 'x_commerce', 'x_customerid', 'x_channel', 'x_usrtx', 'x_api_version', 'x_language']),
    hasImage() {
      return this.data.processorName && this.data.processorName !== '' && !this.imageError
    },
    processorName() {
      return this.data?.processorName[this.$t(`yunoComponent.processorName`)]
    },
    processorLegend() {
      return this.data?.processorLegend?.[this.$t(`yunoComponent.processorLegend`)]
    }
  },
  watch: {
    errorCreatePayment: function () {
      this.currentErrors.push('errorCreatePayment')
      if (!this.errorMPRedirect) {
        this.postErrorStatus(this.errorsDict['errorCreatePayment'])
      }
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    },
    errorPromotionValidation: function () {
      this.currentErrors.push('errorPromotionValidation')
      this.postErrorStatus(this.errorsDict['errorPromotionValidation'])
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    },
    errorPromotionFailed: function () {
      this.currentErrors.push('errorPromotionFailed')
      this.postErrorStatus(this.errorsDict['errorPromotionFailed'])
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    }
  },
  mounted() {
    const image = new Image()
    image.src = this.setImage()
    image.onload = () => {
      this.imageLoaded = true
      this.$emit('loaded')
    }
    image.onerror = () => {
      this.imageError = true
      this.$emit('loaded')
    }
  },
  methods: {
    ...mapMutations(['postErrorStatus', 'backButtonRedirect', 'stopCountdown', 'stopBarCountdown']),
    handleImageError() {
      this.imageError = true // Marcar que ha ocurrido un error al cargar la imagen
    },
    setImage() {
      return `${process.env.VUE_APP_STORAGE}${this.data.processorType}.png`
    },
    base64UrlEncode(str) {
      let base64 = btoa(str)
      base64 = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
      return base64
    },
    selectError() {
      if (this.currentErrors.find((errorName) => errorName === 'errorCreatePayment')) {
        this.errorToShow = this.errorsDict['errorCreatePayment']
      } else if (this.currentErrors.find((errorName) => errorName === 'errorPromotionValidation')) {
        this.errorToShow = this.errorsDict['errorPromotionValidation']
      } else if (this.currentErrors.find((errorName) => errorName === 'errorPromotionFailed')) {
        this.errorToShow = this.errorsDict['errorPromotionFailed']
      }
    },
    getBaseUrl() {
      const currentURL = window.location.href
      const index = currentURL.indexOf('/#/')
      const baseUrl = currentURL.substring(0, index + 3)
      return baseUrl
    },
    async createYunoPayment(tokenParam, checkoutParam, customerParam, currentHeaders, idSessionHash, methodtype) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'selected-payment': 'YUNO',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }
        const res = await axios
          .get(`${process.env.VUE_APP_URL_BFF}/session/payment/yuno/${idSessionHash}?methodType=${methodtype}&checkoutSession=${checkoutParam}&token=${tokenParam}&customerId=${customerParam}`, auth)
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.log('Get error ' + e)
          })
        console.log('Respuesta de createPayment', res)
        return res.data
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    async createYunoCheckout(currentHeaders, idSessionHash) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'selected-payment': 'YUNO',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }
        const res = await axios.get(`${process.env.VUE_APP_URL_BFF}/session/checkout/yuno/${idSessionHash}`, auth).catch((e) => {
          // eslint-disable-next-line no-console
          console.log('Get error ' + e)
        })
        console.log('Respuesta de yunoCheckout', res)
        return res.data
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    async callbackYuno(idSessionHash, currentHeaders, redirectType) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'selected-payment': 'YUNO',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }
        const encodeParams = this.base64UrlEncode(`${idSessionHash}&${currentHeaders.country}&${currentHeaders.commerce}&${currentHeaders.customerid}&${currentHeaders.usrtx}&${redirectType}`)
        const res = await axios
          .get(`${process.env.VUE_APP_URL_ACL_YUNO}/${encodeParams}`, auth)
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.log('Get error ' + e)
          })
        return res.data
        // eslint-disable-next-line no-console
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    async promotionValidation(tokenWithInformation, currentHeaders, idSessionHash) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }

        const body = {
          tokenWithInformation,
          idSessionHash
        }

        const result = await axios.post(`${process.env.VUE_APP_URL_BFF}/payment/promotion`, body, auth).catch((e) => {
          this.errorPromotionFailed = true
          console.log('Get error ' + e)
        })
        return result.data
        // eslint-disable-next-line no-console
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    async startPayment() {
      this.overlay = true
      this.progress = true

      const headers = {
        country: this.x_country,
        commerce: this.x_commerce,
        customerid: this.x_customerid,
        channel: this.x_channel,
        usrtx: this.x_usrtx
      }

      const idSessionHash = this.idSessionHash
      const PAYMENT_METHOD_TYPE = this.data.processorType

      // En caso de que el pago sea con un APM, entonces se redirige toda la ventana (no sólo el iframe)
      if (PAYMENT_METHOD_TYPE !== 'CARD') {
        const baseUrl = this.getBaseUrl()
        window.parent.location = `${baseUrl}redirect/yunoapm/${PAYMENT_METHOD_TYPE}/${idSessionHash}`
        window.location.reload()
        return
      }

      //Encargado de crear al usuario y el checkout de Yuno
      const responseCheckoutYuno = await this.createYunoCheckout(headers, idSessionHash)

      if (!responseCheckoutYuno) {
        this.errorCreatePayment = true
        this.progress = false
        return
      }

      setTimeout(() => {
        this.overlay = false
        this.progress = false
      }, 2000)

      const checkoutSessionValue = responseCheckoutYuno.yuno.json.payment.checkout.session || responseCheckoutYuno.yuno.json.payment.checkout.checkoutSession
      const customerIdValue = responseCheckoutYuno.yuno.json.payment.checkout.customerId
      const publicApiKey = responseCheckoutYuno.yuno.json.payment.checkout.sdkKey
      const VAULTED_TOKEN = null
      const yuno = await Yuno.initialize(publicApiKey)
      const vueContext = this
      await yuno.startCheckout({
        checkoutSession: checkoutSessionValue,
        elementSelector: '#root',
        countryCode: headers.country,
        language: this.x_language?.toLowerCase() || 'es',
        vueContext: vueContext,
        showPaymentStatus: false,
        showLoading: false,
        card: {
          styles: `
            .Yuno-card-icon-bar__content {
              .Yuno-card-icon-bar__icon {
                display: none;
              }
            }
          `
        },

        /**
         * callback is called when one time token is created,
         * merchant should create payment back to back
         * @param { oneTimeToken: string } oneTimeToken
         * @param { tokenWithInformation: object } tokenWithInformation
         */
        async yunoCreatePayment(oneTimeToken, tokenWithInformation) {
          vueContext.overlay = true
          vueContext.progress = true
          //onetimetoken y //tokenWithInformation para bines
          const resValidation = await vueContext.promotionValidation(tokenWithInformation, headers, idSessionHash)
          if (!resValidation?.validation) {
            vueContext.errorPromotionValidation = true
            return
          }

          const yunoRes = await vueContext.createYunoPayment(oneTimeToken, checkoutSessionValue, customerIdValue, headers, idSessionHash, 'CARD', tokenWithInformation)

          // Si existe yunoRes y existe yunoMethodType
          if (yunoRes) {
            if (yunoRes.yuno.json.payment.checkout.sdk_action_required) {
              await yuno.continuePayment()
            } else {
              vueContext.overlayMessage = 'redirectionStore'
              const callback = await vueContext.callbackYuno(idSessionHash, headers, 'RETURN_URL')
              if (callback) {
                window.parent.location = `${callback.url}`
              }
            }
          }
          // En caso de que no existe yunoRes (no se respondió nada desde acl yuno luego de enviar el pago)
          else {
            vueContext.errorCreatePayment = true
          }
        },
        async yunoPaymentResult(data) {
          console.log('Yuno result', data)
        },
        /**
         * @param { error: 'CANCELED_BY_USER' | any }
         */
        yunoError: (error) => {
          console.log('There was an error', error)
          this.overlay = false
          this.progress = false
        }
      })
      await yuno.mountCheckoutLite({
        paymentMethodType: PAYMENT_METHOD_TYPE,
        valutedToken: VAULTED_TOKEN
      })
    }
  }
}
</script>

<style scoped>
.prominent-icon-wrapper {
  position: relative;
  width: 54px;
  height: 54px;
}

.prominent-icon-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.25;
}

.prominent-icon {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
